type Props = { targetId?: string };

const SkipToContentLink = ({ targetId = 'main-content' }: Props) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const el = document.getElementById(targetId);
    if (el) {
      e.preventDefault();
      el.tabIndex = -1 as any;
      (el as HTMLElement).focus();
      el.scrollIntoView({ behavior: 'auto' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:bg-white focus:text-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-dark px-3 py-2 rounded shadow"
    >
      Skip to content
    </a>
  );
};

export default SkipToContentLink;
